// file: raiseTicketPage.jsx
import React, { useEffect, useRef, useState } from "react";
import styles from "./pendingTickets.module.scss";
import { connect, useDispatch } from "react-redux";
import {
  endChatSession,
  getAllCustomer,
  getAllSupportTicket,
  getAllUser,
  getOldMessages,
  updateSupportTicket,
  updateUnSeenChat,
} from "../../store/actions";
import TicketTile from "../../components/uiComponents/ticketTile/TicketTile";
import SockJS from "sockjs-client";
import { Client, Stomp } from "@stomp/stompjs";
import {
  getObjectFromArrayOfObjects,
  getOtherObjectsFromArray,
} from "../../utils/common/CommonFunctions";
import PROFILE_PIC from "../../assets/images/profileImg.png";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import colors from "../../colors";
import { Button, Dialog } from "@mui/material";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import toast from "react-hot-toast";


const PendingTickets = ({
  tickets,
  loginUser,
  messages = [],
  customers,
  users,
}) => {
  const [pending, setPending] = useState([]);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const clientRef = useRef(null);
  const chatEndRef = useRef(null); // for auto-scroll
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [messagesList, setMessagesList] = useState([]);
  const [connected, setConnected] = useState(false);
  const [messageText, setMessageText] = useState("");
  const stompClientRef = useRef(null);
  let stompClient;
  const [showResolveDialog, setShowResolveDialog] = useState(false);
  const [resolveNote, setResolveNote] = useState("");
  const resolveMessageSentRef = useRef(false);
  const resolvePayloadRef = useRef(null);

  const handleResolve = () => {
    setResolveNote("");
    setShowResolveDialog(true);
  };

  //customer start
  const [showCustomerDetails, setShowCustomerDetails] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const getCustomerById = (userId) => {
    return getObjectFromArrayOfObjects(customers, "id", userId);
  };

  const handleCustomerClick = () => {
    const customer = getCustomerById(selectedTicket?.submittedUserId);
    console.log("customer", customer);
    setSelectedCustomer(customer);
    setShowCustomerDetails(true);
  };

  const closeCustomerDetails = () => {
    setShowCustomerDetails(false);
  };

  useEffect(() => {
    dispatch(getAllUser());
  }, []);

  useEffect(() => {
    return () => {
      if (stompClientRef.current) {
        stompClientRef.current.deactivate();
      }
    };
  }, []);

  //customer end

  useEffect(() => {
    if (messages?.length) {
      setMessagesList(messages);
    }
  }, [messages]);

  // 🔹 Load tickets
  useEffect(() => {
    console.log("first");
    dispatch(getAllCustomer());
    dispatch(
      getAllSupportTicket({
        callback: {
          success: (data) => {
            const pending = data?.filter?.(
              (data) => data?.ticket?.status !== 5
            );
            setPending(pending);
          },
        },
      })
    );
  }, []);

  const connect = (ticketId) => {
    console.log(
      "process.env.REACT_APP_WEBSOCKET_BACKEND_URL",
      process.env.REACT_APP_WEBSOCKET_BACKEND_URL
    );
    if (!ticketId) return;

    const client = new Client({
      webSocketFactory: () =>
        new SockJS(`${process.env.REACT_APP_WEBSOCKET_BACKEND_URL}ws`),

      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,

      onConnect: () => {
        console.log("WebSocket Connected");

        client.subscribe(`/topic/ticket/${ticketId}`, (msg) => {
          const receivedMessage = JSON.parse(msg.body);
          console.log("messageList", messagesList);
          console.log("receivedMessage", receivedMessage);

          // ✅ THIS IS THE KEY FIX

          setMessagesList((prev) => [...prev, receivedMessage]);
        });
      },

      onStompError: (frame) => {
        console.error("Broker error:", frame.headers["message"]);
      },
    });

    client.activate();
    stompClientRef.current = client;
  };

  const sendMessage = () => {
    if (!stompClientRef.current || !messageText.trim()) return;

    const message = {
      ticketId: selectedTicket?.id,
      userId: loginUser?.id,
      customerId: null,
      message: messageText,
      timestamp: new Date().toISOString(),
    };
    console.log("web", message);
    stompClientRef.current.publish({
      destination: "/app/chat.send",
      body: JSON.stringify(message),
    });

    setMessageText("");
  };

  const loadOldMessage = async (id) => {
    dispatch(
      getOldMessages({
        id: id,
      })
    );
  };

  const handleClick = (item) => {
    console.log("id", item);
    setShowCustomerDetails(false);
    setSelectedCustomer(null);
    setSelectedTicket(item);
    loadOldMessage(item?.id);
    connect(item?.id);

    if (item?.status === 0) {
      dispatch(
        updateSupportTicket({
          payload: { ...item, status: 1 },
          callback: {
            success: () =>
              dispatch(
                updateUnSeenChat({
                  payload: { id: item?.id, type: "customer" },
                  callback: {
                    success: () =>
                      dispatch(
                        getAllSupportTicket({
                          callback: {
                            success: (data) => {
                              const pending = data?.filter?.(
                                (data) => data?.ticket?.status !== 5
                              );
                              setPending(pending);
                            },
                          },
                        })
                      ),
                  },
                })
              ),
          },
        })
      );
    } else {
      dispatch(
        updateUnSeenChat({
          payload: { id: item?.id, type: "customer" },
          callback: {
            success: () =>
              dispatch(
                getAllSupportTicket({
                  callback: {
                    success: (data) => {
                      const pending = data?.filter?.(
                        (data) => data?.ticket?.status !== 5
                      );
                      setPending(pending);
                    },
                  },
                })
              ),
          },
        })
      );
    }
  };

  const getImage = (userId) => {
    const imageUrl = getObjectFromArrayOfObjects(
      customers,
      "id",
      userId
    )?.imageUrl;
    return imageUrl || PROFILE_PIC;
  };
  const getUserImage = (userId) => {
    const imageUrl = getObjectFromArrayOfObjects(users, "id", userId)?.imageUrl;
    return imageUrl || PROFILE_PIC;
  };

  const filteredTickets = pending?.filter((ticket) => {
    if (!search) return true;

    const searchValue = search.toString().toLowerCase();

    return (
      ticket.cartBundleId?.toString().toLowerCase().includes(searchValue) ||
      ticket.orderId?.toString().toLowerCase().includes(searchValue) ||
      ticket.referenceId?.toString().toLowerCase().includes(searchValue)
    );
  });

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messagesList]);

  const getTicketStatus = (status) => {
    switch (status) {
      case 0:
        return { bg: "#C8E2FB", clr: "#1976D2", title: "Placed" };
        break;
      case 1:
        return { bg: "#FFC89A", clr: "#D97706", title: "In Progress" };
        break;
      case 2:
        return "";
        break;
      case 3:
        return "";
        break;
      case 4:
        return "";
        break;
      case 5:
        return { bg: "#05966933", clr: " #059669", title: "Resolved" };
        break;
      default:
        return { bg: "#C8E2FB", clr: "#1447E6", title: "Placed" };
        break;
    }
  };

  const confirmResolveTicket = () => {
    const message = {
      ticketId: selectedTicket?.id,
      userId: loginUser?.id,
      customerId: null,
      message:
        "Thank you for reaching out to us—your concern has been successfully resolved.",
      timestamp: new Date().toISOString(),
    };

    const payload = {
      ...selectedTicket,
      resolution: resolveNote,
      status: 5,
    };

    dispatch(
      endChatSession({
        payload: { message: message, status: 5 },
        callback: {
          success: () => {
            setShowResolveDialog(false);
            setSelectedTicket(null);
            toast.success("Ticket Resolved Successfully");

            dispatch(
              getAllSupportTicket({
                callback: {
                  success: (data) => {
                    const pending = data?.filter(
                      (d) => d?.ticket?.status !== 5
                    );
                    setPending(pending);
                  },
                },
              })
            );
          },
        },
      })
    );
  };

  const cancelResolve = () => {
    setShowResolveDialog(false);
  };



  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* LEFT PANEL */}
        <div className={styles.left}>
          <input
            className={styles.searchInput}
            placeholder="Search tickets"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className={styles.listWrapper}>
            {search?.length > 0 ? (
              <>
                {filteredTickets?.length > 0 ? (
                  filteredTickets?.map((item) => (
                    <TicketTile
                      key={item.id}
                      data={item}
                      onClick={handleClick}
                      selectedTicket={selectedTicket}
                    />
                  ))
                ) : (
                  <div style={{ textAlign: "center" }}> Results Not Found</div>
                )}
              </>
            ) : (
              pending?.map((item) => (
                <TicketTile
                  key={item.id}
                  data={item?.ticket}
                  onClick={handleClick}
                  selectedTicket={selectedTicket}
                  unreadCount={item?.unseenCount}
                />
              ))
            )}
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div
          className={styles.right}
          style={{
            width: showCustomerDetails ? "65%" : "100%",
            transition: "width 0.3s ease",
          }}
        >
          {selectedTicket?.id && (
            <div className={styles.rightWrapper}>
              {/* HEADER */}
              <div className={styles.top}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div>
                    <h3 className={styles.ticketTitle}>
                      Ticket ID {selectedTicket?.referenceId || "-"}
                    </h3>

                    <span
                      style={{
                        color: colors?.$primaryColor,
                        cursor: "pointer",
                        fontSize: "14px",
                        textDecoration: "underline",
                        textTransform: "capitalize",
                      }}
                      onClick={handleCustomerClick}
                    >
                      {getCustomerById(selectedTicket?.customerId)?.fullName ||
                        "Customer"}
                    </span>
                  </div>

                  <span
                    style={{
                      color: getTicketStatus(selectedTicket?.status)?.clr,
                      backgroundColor: getTicketStatus(selectedTicket?.status)
                        ?.bg,
                      padding: "6px 14px",
                      borderRadius: "16px",
                      height: "fit-content",
                      fontSize: "12px",
                    }}
                  >
                    {getTicketStatus(selectedTicket?.status)?.title}
                  </span>
                </div>

                <CustomButton
                  title={"Resolve Ticket"}
                  background={colors?.$primaryColor}
                  borderRadius={20}
                  onClick={() => handleResolve()}
                />
              </div>

              {/* CHAT AREA */}
              <div className={styles.chatArea}>
                <div className={styles.messageRow}>
                  <div className={styles.avatar}>
                    <div className={styles.avatarWrapper}>
                      <img
                        src={getImage(selectedTicket?.submittedUserId)}
                        className={styles.avatarImg}
                      />
                    </div>
                  </div>

                  <div
                    className={styles.messageLeft}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <div>Subject : {selectedTicket?.subject || "NA"}</div>
                    <div>
                      Description : {selectedTicket?.description || "NA"}
                    </div>
                    {selectedTicket?.imageUrl && (
                      <div style={{ width: "200px" }}>
                        <img
                          src={selectedTicket?.imageUrl}
                          style={{ width: "100%" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {messagesList?.length > 0 &&
                  messagesList?.map((msg, index) => (
                    <div
                      key={index}
                      className={
                        msg?.userId ? styles.messageRowRight : styles.messageRow
                      }
                    >
                      {msg?.customerId && (
                        <div className={styles.avatar}>
                          <div className={styles.avatarWrapper}>
                            <img
                              src={getImage(selectedTicket?.submittedUserId)}
                              className={styles.avatarImg}
                            />
                          </div>
                        </div>
                      )}

                      <div
                        className={
                          msg?.userId ? styles.messageRight : styles.messageLeft
                        }
                      >
                        {msg?.message}
                      </div>
                      {msg?.userId && (
                        <div className={styles.avatar}>
                          <div className={styles.avatarWrapper}>
                            <img
                              src={getUserImage(msg?.userId)}
                              className={styles.avatarImg}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                <div ref={chatEndRef} />
              </div>

              {/* INPUT */}
              {selectedTicket?.id && (
                <div className={styles.bottom}>
                  <input
                    className={styles.messageInput}
                    placeholder="Type a message"
                    value={messageText}
                    onChange={(e) => setMessageText(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                  />
                  <button className={styles.sendButton} onClick={sendMessage}>
                    ➤
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        {showCustomerDetails && (
          <div
            style={{
              width: "320px",
              borderLeft: "1px solid #e0e0e0",
              background: "#ffffff",
              padding: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5>Customer Details</h5>
              <span
                style={{ cursor: "pointer", fontWeight: "bold" }}
                onClick={closeCustomerDetails}
              >
                ✕
              </span>
            </div>

            <div style={{ marginTop: "16px", textAlign: "center" }}>
              <img
                src={selectedCustomer?.imageUrl || PROFILE_PIC}
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginBottom: "10px",
                }}
              />

              <p style={{ textAlign: "left" }}>
                <b>Name:</b> {selectedCustomer?.fullName || "-"}
              </p>
              <p style={{ textAlign: "left" }}>
                {" "}
                <b>Email:</b> {selectedCustomer?.email || "-"}
              </p>
              <p style={{ textAlign: "left" }}>
                <b>Mobile:</b> {selectedCustomer?.phoneNumber || "-"}
              </p>
            </div>
          </div>
        )}
      </div>

      <Dialog open={showResolveDialog} onClose={() => cancelResolve()}>
        <div
          style={{
            width: "420px",
            background: "#fff",
            borderRadius: "10px",
            padding: "20px",
            position: "relative",
          }}
        >
          <h4 style={{ marginBottom: "12px" }}>Resolve Ticket</h4>

          <span
            style={{
              cursor: "pointer",
              fontWeight: "bold",
              position: "absolute",
              top: "5%",
              right: "5%",
            }}
            onClick={cancelResolve}
          >
            ✕
          </span>

          <p>
            <b>Ticket ID:</b> {selectedTicket?.referenceId || "-"}
          </p>

          <label
            style={{
              fontSize: "14px",
              marginTop: "10px",
              display: "block",
            }}
          >
            Note
          </label>

          <textarea
            rows={4}
            value={resolveNote}
            onChange={(e) => setResolveNote(e.target.value)}
            placeholder="Enter resolution note..."
            style={{
              width: "100%",
              marginTop: "6px",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              resize: "none",
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "16px",
            }}
          >
            <CustomButton
              title="Confirm"
              background={
                !resolveNote?.length > 0 ? "grey" : colors?.$primaryColor
              }
              onClick={confirmResolveTicket}
              disabled={!resolveNote?.length > 0}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  tickets: state?.supporttickets?.tickets,
  messages: state?.supporttickets?.messages,
  customers: state?.customer?.customers,
  loginUser: state?.login?.user, // logged-in user ID
  users: state?.user?.users,
});

export default connect(mapStateToProps)(PendingTickets);
